import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'cub-layout-simple',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './layout-simple.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './layout-simple.component.scss'
})
export class LayoutSimpleComponent {

}
